// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type RegionSummary = {
  code: string,
  datacenters: Array<{
    code: string,
    name: string,
    region: string,
  }>,
};

export type State = {
  list: ListState<RegionSummary>,
};

type RegionsResourceType = SequoiaResourceType<{
  fetchResource: RegionSummary,
}>;

export type RegionsResource = SequoiaResource<RegionsResourceType>;

export const regionsResource: RegionsResource = createSequoiaResource(
  'cloud',
  'regions',
  {
    fetchPath: 'hosting/regions',
    getResourceId(resource) {
      return resource.code;
    },
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...regionsResource.listReducer,
});
